import React from 'react';
import Relay from 'react-relay';

import { css } from 'glamor';

import { FormattedMessage } from 'react-intl';
import DeeplinkConfig from 'depop/components/deeplinks/Deeplink';
import Application from 'depop/root/containers/Application';

import { ScrollTop } from 'depop/components/scroll';

import FeaturedProducts from '../components/FeaturedProducts';

class Homepage extends React.Component {
  props: {
    viewer: Object,
    relay: Object,
  };

  loadMore = numResults => {
    window.history.replaceState(
      {
        ...window.history.state,
        numResults,
      },
      null,
      null,
    );
  };

  render() {
    const { viewer } = this.props;

    return (
      <Application viewer={viewer}>
        <ScrollTop />
        <DeeplinkConfig
          path="explore"
          referer=""
          canonicalUrl="https://www.depop.com/"
        />
        {!viewer.currentUser &&
          <p
            style={{
              fontSize: 14,
              margin: '0 0 2em',
              maxWidth: '40em',
              lineHeight: '1.3',
            }}
          >
            <FormattedMessage
              id="Homepage.greeting"
              description="Greeting to welcome the user to the website"
              defaultMessage="Hello, we're open. Hello we're Depop. We inspire people to find things they love. We believe in passion, creativity and connection. We believe that shopping should be fun and easy. Create your own shop, discover and share your favorite things. Welcome to our community."
            />
          </p>}

        <h1 {...css({ marginBottom: 20 })}>
          <FormattedMessage
            id="Homepage.exploreHeading"
            description="Heading for explore feed"
            defaultMessage="Explore items"
          />
        </h1>
        <FeaturedProducts
          viewer={viewer}
          loadedMore={this.loadMore}
          numResults={this.props.relay.variables.numResults}
        />
      </Application>
    );
  }
}

export default Relay.createContainer(Homepage, {
  initialVariables: {
    numResults: null,
  },
  fragments: {
    viewer: ({ numResults }) => Relay.QL`
      fragment on Viewer {
        currentUser {
          id
        }
        ${Application.getFragment('viewer')}
        ${FeaturedProducts.getFragment('viewer', { numResults })}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/root/views/Homepage.js